/** html検証ツールクラス */

//xssポリシー違反文字列
const XSS_CHARACTERS = ['&', '<', '>', '\\', '\''];

/**
 * 文字列にxssポリシー違反文字列が含まれているかどうかを判断する
 * @param {input} 文字列 
 * @returns ブール型 true: 含める false: 含まない
 */
export function containsXSSCharacters(input) {
  if (!input || input.length === 0) {
      return false;
  }

  for (let i = 0; i < XSS_CHARACTERS.length; i++) {
      if (input.indexOf(XSS_CHARACTERS[i]) >= 0) {
          return true;
      }
  }
  return false;
}

